<template>
  <div>
    <!-- Add advancesearch modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="AdvanceSearch"
      size="lg"
      ref="AdvanceSearch"
      body-class="bg-white"
      cancel-title="Close"
      cancel-variant="light"
      ok-title="Search"
      @ok="handleOk"
      title="Advance Search"
    >
      <!-- validation -->
      <div>
        <b-row>
          <b-col xl="12" lg="12" md="12" xs="12" sm="12">
            <div class="container-fluid">
              <b-alert
                class="alert-transparent alert-danger"
                :show="error_show && errors.items.length > 0"
              >
                <button type="button" @click="error_show = !error_show" class="close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div v-for="(item,index) in errors.items" :key="index">
                  <p class="fw-semi-bold">{{ item.msg }}</p>
                </div>
              </b-alert>
            </div>
          </b-col>
        </b-row>
      </div>

      <FilterForm
        v-if="custom != null"
        :items="items"
        :custom="custom"
        :settings="$store.state.permission[settings] || {}"
        v-on:submit="submit"
      />
    </b-modal>
  </div>
</template>
<script>
import FilterForm from "@/components/Form/FilterForm";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
export default {
  props: ["module"],
  components: {
    FilterForm
  },
  data() {
    return {
      custom: {},
      settings: "",
      error_show: false,
      items: [
        {
          generatemessage: "Type to search",
          autoselect: "",
          arrayvalues: [],
          options: [],
          filter_matching: "",
          columns: "",
          cat: "",
          field: "",
          comparator: "",
          value: "",
          type: "text"
        }
      ]
    };
  },
  created() {
    this.callcustomfields();
  },
  watch: {
    module: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.callcustomfields();
      }
    }
  },
  methods: {
    async callcustomfields() {
      this.items = await [];
      await this.$store
        .dispatch(
          "settings/filterdetails",
          JSON.stringify({
            stg_menu: this.module
          })
        )
        .then(result => {
          this.custom = result.custom;
          this.settings = result.custom ? result.custom.settings : {};
        });
    },
    submit(ev) {
      if (ev.result == false) {
        this.error_show = true;
      }
      if (ev.result == true) {
        this.$router.push({
          name: this.$route.name,
          index: this.index,
          query: {
            from_date: this.$route.query.from_date,
            to_date: this.$route.query.to_date,
            custom: JSON.stringify({
              columns: JSON.stringify(this.items)
            })
          }
        });
        this.$refs.AdvanceSearch.hide();
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.Search();
    },
    //search
    Search() {
      EventBus.$emit("validatefilter");
    }
  }
};
</script>
<style scoped>
.navbar .form-control {
  line-height: 13px !important;
  padding-top: 7px !important;
  padding-bottom: 1px !important;
}
</style>
<style >
.adv_del {
  padding-top: 6px;
}
</style>